import React, { Component } from 'react';

class DetectLoader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      component: null
    };
  }

  // TODO: Update logic when migrating to React 17
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    return import(/* webpackChunkName: "zen/Detect.zen" */ './Detect')
      .then((Detect) => {
        this.setState({component: Detect.default});
      }).catch(
      // eslint-disable-next-line no-console
        (error) => console.error('An error occurred while loading \'Detect\'',error)
      );
  }

  render () {
    return (
      <span>{this.state.component && (<this.state.component {...this.props} />)}</span>
    );
  }
}

export default DetectLoader;
